export enum FeatureName {
  Kunder = 'Kunder',
  Skabeloner = 'Skabeloner',
  Synkroniseringer = 'Synkroniseringer',
  Adgange = 'Adgange',
}
